"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillsRequest = exports.transformBillsParsedResponse = exports.transformBillsListResponse = exports.transformBillsResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("./Money");
const Date_1 = require("./Date");
const Error_1 = require("./Error");
const BillPayments_1 = require("./BillPayments");
const BillLines_1 = require("./BillLines");
const BillVendors_1 = require("./BillVendors");
var BillStatus;
(function (BillStatus) {
    BillStatus["unpaid"] = "unpaid";
    BillStatus["overdue"] = "overdue";
    BillStatus["partial"] = "partial";
    BillStatus["paid"] = "paid";
})(BillStatus || (BillStatus = {}));
function transformBillsResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { bill } = response.response.result;
    return transformBillsParsedResponse(bill);
}
exports.transformBillsResponse = transformBillsResponse;
function transformBillsListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { bills, per_page, total, page, pages } = response.response.result;
    return {
        bills: bills.map((bill) => transformBillsParsedResponse(bill)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformBillsListResponse = transformBillsListResponse;
function transformBillsParsedResponse(bill) {
    return {
        id: bill.id,
        amount: bill.amount && (0, Money_1.transformMoneyParsedResponse)(bill.amount),
        attachment: bill.attachment,
        billNumber: bill.bill_number,
        billPayments: bill.bill_payments &&
            bill.bill_payments.map((payment) => (0, BillPayments_1.transformBillPaymentsParsedResponse)(payment)),
        createdAt: bill.created_at && (0, Date_1.transformDateResponse)(bill.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss'], 'UTC'),
        currencyCode: bill.currency_code,
        dueDate: bill.due_date && (0, Date_1.transformDateResponse)(bill.due_date, Date_1.DateFormat['YYYY-MM-DD']),
        dueOffsetDays: bill.due_offset_days,
        issueDate: bill.issue_date && (0, Date_1.transformDateResponse)(bill.issue_date, Date_1.DateFormat['YYYY-MM-DD']),
        language: bill.language,
        lines: bill.lines && bill.lines.map((line) => (0, BillLines_1.transformBillLinesParsedResponse)(line)),
        outstanding: bill.outstanding && (0, Money_1.transformMoneyParsedResponse)(bill.outstanding),
        overallCategory: bill.overall_category,
        overallDescription: bill.overall_description,
        paid: bill.paid && (0, Money_1.transformMoneyParsedResponse)(bill.paid),
        status: bill.status,
        taxAmount: bill.tax_amount && (0, Money_1.transformMoneyParsedResponse)(bill.tax_amount),
        totalAmount: bill.total_amount && (0, Money_1.transformMoneyParsedResponse)(bill.total_amount),
        updatedAt: bill.updated_at && (0, Date_1.transformDateResponse)(bill.updated_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss'], 'UTC'),
        vendorId: bill.vendorid,
        visState: bill.vis_state,
        vendor: bill.vendor && (0, BillVendors_1.transformBillVendorsParsedResponse)(bill.vendor),
    };
}
exports.transformBillsParsedResponse = transformBillsParsedResponse;
function transformBillsRequest(bill) {
    return JSON.stringify({
        bill: {
            id: bill.id,
            attachment: bill.attachment,
            bill_number: bill.billNumber,
            bill_payments: bill.billPayments &&
                bill.billPayments.map((payment) => (0, BillPayments_1.transformBillPaymentsParsedResponse)(payment)),
            currency_code: bill.currencyCode,
            due_date: bill.dueDate && (0, Date_1.transformDateRequest)(bill.dueDate),
            due_offset_days: bill.dueOffsetDays,
            issue_date: bill.issueDate && (0, Date_1.transformDateRequest)(bill.issueDate),
            language: bill.language,
            lines: bill.lines && bill.lines.map((line) => (0, BillLines_1.transformBillLinesParsedRequest)(line)),
            vendorid: bill.vendorId,
            vis_state: bill.visState,
        },
    });
}
exports.transformBillsRequest = transformBillsRequest;
//# sourceMappingURL=Bills.js.map